import type { BridgeRequest, BridgeResponse } from "types/native-bridge"

export const ANDROID_USER_AGENT = "WebPackaging-Android"
export const IOS_USER_AGENT = "WebPackaging-iOS"

const responseResolvers = new Map<
  string,
  (response: BridgeResponse<unknown>) => void
>()

// request 보낼 땐 Promise<BridgeResponse> 반환
export function callNativeMessage<T, R>(
  payload: Omit<BridgeRequest<T>, "requestId">,
): Promise<BridgeResponse<R>>
// response 보낼 땐 void 반환
export function callNativeMessage<R>(payload: BridgeResponse<R>): void

export function callNativeMessage<T, R>(
  payload: Omit<BridgeRequest<T>, "requestId"> | BridgeResponse<R>,
): Promise<BridgeResponse<R>> | void {
  let outgoingMessage: BridgeRequest<T> | BridgeResponse<R>

  if (payload.type === "request") {
    const requestId = crypto.randomUUID()
    outgoingMessage = { ...payload, requestId }
  } else {
    outgoingMessage = payload
  }
  const message = JSON.stringify(outgoingMessage)

  // Android
  if (
    navigator.userAgent.includes(ANDROID_USER_AGENT) &&
    window.Android?.postMessage
  ) {
    window.Android.postMessage(message)
  }
  // iOS
  else if (
    navigator.userAgent.includes(IOS_USER_AGENT) &&
    window.webkit?.messageHandlers?.bridgeHandler?.postMessage
  ) {
    window.webkit.messageHandlers.bridgeHandler.postMessage(message)
  } else {
    // Dev 모드로 실행 중인 경우
    if (import.meta.env.DEV) {
      // 네이티브 브리지 없음 (웹테스트용 폴백)
      if (payload.type === "request") {
        const { handlerName, requestId } = outgoingMessage
        const response: BridgeResponse<{ isGranted: false }> = {
          type: "response",
          isSuccess: true,
          handlerName,
          requestId,
          result: { isGranted: false },
        }
        return Promise.resolve(response as BridgeResponse<R>)
      }
    }

    return
  }

  if (payload.type === "request") {
    return new Promise<BridgeResponse<R>>((resolve) => {
      // BridgeResponse 가 돌아올 때 resolveNativeResponse로 해제
      responseResolvers.set(
        outgoingMessage.requestId,
        resolve as (response: BridgeResponse<unknown>) => void,
      )
    })
  }
}

/**
 * 네이티브에서 온 response를 resolve
 */
export function resolveNativeResponse(response: BridgeResponse) {
  const resolve = responseResolvers.get(response.requestId)
  if (resolve) {
    resolve(response)
    responseResolvers.delete(response.requestId)
  }
}
